module.exports = __webpack_public_path__ + "static/media/dg.942e498b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/DG/dg.jpg
// module id = 371
// module chunks = 0